import { store } from '@/decorators/store';
import { TripNoteType } from '@/entities/TripNoteType';
import { AbstractEntityStore } from '@/stores/AbstractEntityStore';

@store({ id: 'TripNoteType' })
export class TripNoteTypeStore extends AbstractEntityStore<TripNoteType> {
  protected entityIdKey = 'id';
  protected entityValueKey = 'value';
}
